
$(document).ready(function () {
    //cart
    //delete
    let $currentTarget;
    $('.cart-modal').on('click', '.cart-modal__list__item .remove', function(e){
        e.preventDefault();
        $(this).closest('.modal-content').find('.move-item_block').slideDown(200, function() {
            $('.custom_scrollbar_y').mCustomScrollbar('scrollTo', 'top');
        });
        $currentTarget = $(this).closest('.cart-modal__list__item');
    });

    // Remove cart items
    $('.cart-modal').on('click', '.move-item_block .remove-btn', function() {
        var $this = $(this);
        var platform_id = $currentTarget.attr('data-platform_id');
        var req = $.ajax({
            method: 'post',
            url: $(this).attr('data-action'),
            data: {'id': $currentTarget.attr('data-id'), 'fav': $this.attr('data-fav'), '_token': CSRF_TOKEN},
        });
        req.then(function(resp) {
            if (resp.success) {
                $currentTarget.slideUp(200, function() {
                    $(this).remove();
                    calcCartNumber($('.cart-modal'), ('.cart-modal__list__item'), ('.cart-number'), ('.content-header .basket-link .number'));
                    calculateCartTotal($('.cart-modal'), '.cart-modal__list__item', '.cart-modal__item__price .item-price', '.cart-modal__item__price .sale-price', '.price-sum .value span', '.sale-sum .value span', '.total-sum .value span', '.check-price', '.check-sale');
                });
                $this.closest('.move-item_block').slideUp(200);
                if (resp.id && resp.format) {
                    $('.product-content--right[data-id='+resp.id+'] [data-format='+resp.format+']').find('label').attr('data-cart', '')
                    $('.catalog-item[data-id='+resp.id+'] [data-format='+resp.format+']').find('label').attr('data-cart', '');
                }
                if (resp.id) {
                    $('.product-content--right[data-id=' + resp.id + ']').find('input:checked').click();
                    $('.catalog-item[data-id='+resp.id+']').find('input:checked').click();
                }
                if (resp.header_link) {
                    $('.header-link-item.basket-link').html(resp.header_link);
                }
                if (resp.fav_text) {
                    $('.js-favorite-nav').text(resp.fav_text);
                }
                if (resp.header_fav_link) {
                    $('.header-link-item.favorite-link').html(resp.header_fav_link);
                }
                if (resp.favorite_button) {
                    $('.catalog-item[data-id='+platform_id+']').find('.js-favorite-button').replaceWith(resp.favorite_button);
                }
                $('.custom_scrollbar_y').mCustomScrollbar({
                    theme: "minimal-dark",
                });
            }
        });
    });

    $('.cart-modal').on('click', '.move-item_block .cancel-remove-btn', function() {
        $(this).closest('.move-item_block').slideUp(200);
    });

    //cart
    //add
    $('.wrap_content').on('click', 'a[data-popup=addCart]', function () {
        $('#addCart').find('input[name=new_name]').val('');
        if ($(this).closest('.catalog-item').length) {
            var id = $(this).closest('.catalog-item').attr('data-id');
        }
        if ($(this).closest('.product-content--right').length) {
            var id = $(this).closest('.product-content--right').attr('data-id');
        }
        $('#addCart').find('input[name=id]').val(id);
    });

    $('#addCart').on('click', '.confirm-btn', function () {
        if ($('#addCart #add_cart_project_new').is(':checked')) {
            if ($('#addCart .for-new-name input').val().trim() == '') {
                $('#addCart .for-new-name .error').show();
                return false;
            }
        };
        var project_id = $('#addCart').find('input[name=add_project_id]:checked').val();
        var name = $('#addCart').find('input[name=new_name]').val();
        var id = $('#addCart').find('input[name=id]').val();
        var formats = [];
        var services = {};
        var guarantee = {};
        if ($('.catalog-item[data-id='+id+']').length) {
            $('.catalog-item[data-id=' + id + ']').find('input[name="format[]"]:checked').each(function (index) {
                formats.push($(this).val());
            });
        }
        if ($('.product-content--right').length) {
            $('.product-content--right').find('input[name="format[]"]:checked').each(function (index) {
                formats.push($(this).val());
                if ($(this).closest('.format-row').length) {
                    var format = $(this).val();
                    services[format] = [];
                    guarantee[format] = [];
                    $(this).closest('.format-row').find('input[name="service[]"]:checked').each(function (index) {
                        services[format].push($(this).val());
                    });
                    $(this).closest('.format-row').find('input[name="guarantee[]"]:checked').each(function (index) {
                        guarantee[format].push($(this).val());
                    });
                }
            });
        }

        var req = $.ajax({
            method: 'post',
            url: $('#addCart .confirm-btn').attr('data-action'),
            data: {'id': id, 'formats': formats, 'services': services, 'project_id': project_id,
                'name': name, 'guarantee': guarantee, '_token': CSRF_TOKEN},
        });
        req.then(function(resp) {
            if (resp.success) {
                $('.catalog-item[data-id='+id+']').find('.checkbox-col input:checked').siblings('label').attr('data-cart', '1');
                $('.product-content--right[data-id='+id+']').find('input:checked').siblings('label').attr('data-cart', '1');
                $('.catalog-item[data-id='+id+']').find('.cart-btn.basket-link').show();
                $('.catalog-item[data-id='+id+']').find('.cart-btn.js-cart-button').hide();
                $('.product-content--right[data-id='+id+']').find('.cart-btn.basket-link').show();
                $('.product-content--right[data-id='+id+']').find('.cart-btn.js-cart-button').hide();

                if (resp.cart_modal) {
                    $('.cart-modal').html(resp.cart_modal);
                }
                if (resp.modal) {
                    setTimeout(function(){
                        $('#addCart .modal-content').replaceWith(resp.modal);
                    },200);
                }
                if (resp.header_link) {
                    $('.header-link-item.basket-link').html(resp.header_link);
                }

                calcCartNumber($('.cart-modal'), ('.cart-modal__list__item'), ('.cart-number'), ('.content-header .basket-link .number'));
                calculateCartTotal($('.cart-modal'), '.cart-modal__list__item', '.cart-modal__item__price .item-price', '.cart-modal__item__price .sale-price', '.price-sum .value span', '.sale-sum .value span', '.total-sum .value span', '.check-price', '.check-sale');
                $('#addCart').find('.close').trigger('click');

                $('.custom_scrollbar_y').mCustomScrollbar({
                    theme: "minimal-dark",
                });
            }
        });
    });

    // Calculate service
    function calcCartNumber(parent, item, cartNumber, headerNumber) {
        parent.find(cartNumber).text($(item).length);
        $(headerNumber).text($(item).length);
        if($(item).length == 0) {
            parent.find('.empty-text').show();
        }
    };
    calcCartNumber($('.cart-modal'), ('.cart-modal__list__item'), ('.cart-number'), ('.content-header .basket-link .number'));

    //cart calulate
    function calculateCartTotal(parent, item, price, sale, totalPrice, totalSale, totalSum, priceCheck, saleCheck) {
        var countTotal = 0, 
            counteSale = 0;
        if(parent.length) {
            $(item).each(function() {
                countTotal += parseFloat($(this).find(price).text().replace(/\s/g, '').replace(',', '.'));
                if($(this).find(sale).length) {
                    counteSale += parseFloat($(this).find(sale).text().replace(/\s/g, '').replace(',', '.')) - parseFloat($(this).find(price).text().replace(/\s/g, '').replace(',', '.'));
                }
                if($(this).find('input:checked').length) {
                    $(this).find('input:checked').each(function() {
                        countTotal += parseFloat($(this).siblings('label').find(priceCheck).text().replace(/\s/g, '').replace(',', '.'));
                        if($(this).siblings('label').find(saleCheck).length) {
                            counteSale += parseFloat($(this).siblings('label').find(saleCheck).text().replace(/\s/g, '').replace(',', '.')) - parseFloat($(this).siblings('label').find(priceCheck).text().replace(/\s/g, '').replace(',', '.'));
                        }
                    });
                }
            });
        }
        var priceTotal = parent.find(totalPrice),
            saleTotal = parent.find(totalSale),
            cartTotal = parent.find(totalSum);

        priceTotal.text((countTotal + counteSale).toFixed(1));
        saleTotal.text(counteSale > 0 ? '-' + counteSale.toFixed(1) : counteSale.toFixed(1));
        cartTotal.text(countTotal.toFixed(1));
        $('.js-header-cart-price').text(countTotal.toFixed(1));

        //balance check
        var req = $.ajax({
            method: 'get',
            url: $('.js-cart-modal-footer').attr('data-balance'),
        });
        req.then(function(resp) {
            if (resp.success) {
                if (resp.balance) {
                    if (resp.balance >= countTotal) {
                        $('.js-cart-modal-footer').find('.cart-modal_error').hide();
                        $('.js-balance-button').hide();
                        $('.js-cart-modal-footer').find('.js-checkout-button').attr('disabled', false);
                    } else {
                        $('.js-cart-modal-footer').find('.cart-modal_error').show();
                        $('.js-balance-button').show();
                        $('.js-cart-modal-footer').find('.js-checkout-button').attr('disabled', true);
                    }
                }
            }
        });
    };
    calculateCartTotal($('.cart-modal'), $('.cart-modal__list__item'), '.cart-modal__item__price .item-price', '.cart-modal__item__price .sale-price', '.price-sum .value span', '.sale-sum .value span', '.total-sum .value span', '.check-price', '.check-sale');

    $('.cart-modal').on('change', '.checkbox-group input', function() {
        calculateCartTotal($('.cart-modal'), '.cart-modal__list__item', '.cart-modal__item__price .item-price', '.cart-modal__item__price .sale-price', '.price-sum .value span', '.sale-sum .value span', '.total-sum .value span', '.check-price', '.check-sale');
    });

    //cart accordion
    $('.cart-modal').on('click', '.slide-down-check', function() {
        if ($(window).width() < 768) {
            $(this).toggleClass('open');
            $(this).next('.cart-modal__list__item--bottom').slideToggle(200);
        }
    });

    $('.cart-modal').on('click', '.js-checkout-button', function () {
        $(this).attr('disabled', true);
        var req = $.ajax({
            method: 'post',
            url: $(this).attr('data-action'),
            data: $('.cart-modal').find('input').serialize(),
        });
        req.then(function(resp) {
            if (resp.success) {
                if (resp.href) {
                    location.href = resp.href;
                }
            }
            $(this).attr('disabled', false);
        });
    })
});
